export default __webpack_public_path__ + "static/media/instagram-original.a4c8527a.svg";